"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/redux-actions@2.6.5/~/redux-actions/lib/utils/isPlainObject.js
// module id = 101
// module chunks = 0